import axios, {
  AxiosError,
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { getToken } from '../tokenUtils';
import { redirectToPlumApp } from '..';
import { logger } from '../logger';
import AppConfig from '@/AppConfig';

const TOKEN_NOT_FOUND_ERROR = 'Token not found in cookies';

export const axiosBaseConfig: AxiosRequestConfig = {
  timeout: 60000,
};

export const setupInterceptors = (
  axiosInstance: AxiosInstance,
  isDev?: boolean,
) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.headers?.['x-plum-token'] === 'skip') {
        delete config.headers['x-plum-token'];
        return config;
      }

      const xPlumToken = getToken();
      if (!xPlumToken) {
        // Cancel the request if the xPlumToken is not present
        return Promise.reject(new axios.Cancel(TOKEN_NOT_FOUND_ERROR));
      }

      if (config.headers) {
        config.headers['x-plum-token'] = xPlumToken;
      } else {
        /*@ts-expect-error
         */
        config.headers = {
          'x-plum-token': xPlumToken,
        };
      }
      if (isDev) {
        const internalToken = AppConfig.INTERNAL_TOKEN;
        if (internalToken) {
          config.headers['x-plum-internal-token'] = internalToken;
        } else {
          window.dev?.e('Internal token not found in AppConfig');
        }
      }
      return config;
    },
    (error) => {
      window.dev?.e('Error in request interceptor', error);
      logger.error('Error in request interceptor', error);
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      window.dev?.e('Error in response interceptor', error);
      logger.error('Error in response interceptor', error);
      window.dev?.e(error.message === TOKEN_NOT_FOUND_ERROR);
      if (
        error.response?.status === 401 ||
        error.message === TOKEN_NOT_FOUND_ERROR
      ) {
        if (typeof window?.NativeBridge?.onNativeLogout === 'function') {
          window?.NativeBridge?.onNativeLogout();
        } else {
          const redirectToUrl = encodeURI(window.location.href);
          redirectToPlumApp(`/logout?redirectTo=${redirectToUrl}`)();
        }
      }
      return Promise.reject(error);
    },
  );
};

export default { axiosBaseConfig, setupInterceptors };
